import { render, staticRenderFns } from "./artistMV.vue?vue&type=template&id=2ee89e1e&scoped=true&"
import script from "./artistMV.vue?vue&type=script&lang=js&"
export * from "./artistMV.vue?vue&type=script&lang=js&"
import style0 from "./artistMV.vue?vue&type=style&index=0&id=2ee89e1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee89e1e",
  null
  
)

export default component.exports